import { FormControl, FormLabel, Stack } from "@mui/material";
import type { Control } from "react-hook-form";
import FormCheckbox from "../../components/formComponents/FormCheckbox";
import FormTextField from "../../components/formComponents/FormTextField";
import type { ProviderFormState } from "./ProviderEdit";

interface Props {
  readonly control: Control<ProviderFormState>;
  readonly disabled?: boolean;
}

const ParticipantListRequiredFieldsSelect = ({ control, disabled }: Props) => {
  return (
    <FormControl sx={{ width: "100%" }}>
      <FormLabel>Pola wymagane w liście uczestników</FormLabel>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <FormCheckbox label="Płeć" name="participantListRequiredFields.gender" control={control} disabled={disabled} />
        <FormCheckbox
          label="Data urodzenia"
          name="participantListRequiredFields.dateOfBirth"
          control={control}
          disabled={disabled}
        />
        <FormCheckbox
          label="Obywatelstwo"
          name="participantListRequiredFields.citizenship"
          control={control}
          disabled={disabled}
        />
        <FormCheckbox
          label="Numer dokumentu"
          name="participantListRequiredFields.documentNumber"
          control={control}
          disabled={disabled}
        />
        <FormCheckbox
          label="Data ważności dokumentu"
          name="participantListRequiredFields.documentExpiryDate"
          control={control}
          disabled={disabled}
        />
        <FormTextField
          label="Format daty dla dostawcy"
          name="participantListRequiredFields.exportDateFormat"
          helperText="np. DD.MM.YYYY"
          fullWidth={false}
          control={control}
          disabled={disabled}
          rules={{
            pattern: {
              value: /^[MDY./-]+$/,
              message: "Dozwolone tylko litery M, D, Y oraz znaki . / -",
            },
          }}
        />
      </Stack>
    </FormControl>
  );
};

export default ParticipantListRequiredFieldsSelect;
